import React, { useEffect, useState, Fragment } from "react";
import { segments } from '../../utils/path';
import styles from './Path.less';
export default function Path({ path, type }) {
    const [items, setItems] = useState([]);
    useEffect(() => setItems(segments(path)), [path]);
    return React.createElement("span", { className: styles.root + ' path-breadcrumbs' },
        type != undefined && React.createElement(React.Fragment, null,
            React.createElement("i", { className: "icon" }, type == 'local' ? 'computer' : 'cloud'),
            React.createElement("i", null, "\u203A")),
        items.map((item, i) => React.createElement(Fragment, { key: i },
            item,
            i < items.length - 1 && React.createElement("i", null, "\u203A"))));
}
